import EtchAnchorLinks from './EtchAnchorLinks.component';

export default EtchAnchorLinks;
